import Button, { ButtonProps } from "shared/Button/Button";
import React from "react";

export interface ButtonSecondaryProps extends ButtonProps {}

const ButtonSecondary: React.FC<ButtonSecondaryProps> = ({
  className = " ",
  ...args
}) => {
  return (
    <Button
      className={`button-secondary font-bold border bg-main/10 border-main text-main hover:bg-main hover:text-white ${className}`}
      {...args}
    />
  );
};

export default ButtonSecondary;
